"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _propTypes = _interopRequireWildcard(require("prop-types"));

var _constant = require("../Theme/constant");

var _constant2 = require("../constant");

var _constant3 = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // TODO: need to review the below changes!!


var locale = {
  noResultLabel: _propTypes.default.string,
  loadOptions: _propTypes.default.string,
  recentSearch: _propTypes.default.string,
  noRightKeywordLabel: _propTypes.default.string,
  clear: _propTypes.default.string,
  searchForLabel: _propTypes.default.string
};
var _default = {
  PropTypes: {
    onFocus: _propTypes.default.func,
    onBlur: _propTypes.default.func,
    onSelect: _propTypes.default.func.isRequired,
    onChange: _propTypes.default.func.isRequired,
    label: _propTypes.default.string.isRequired,
    theme: _propTypes.default.string,
    defaultIcon: _propTypes.default.string,
    placeHolder: _propTypes.default.string,
    items: _propTypes.default.array,
    accessible: _propTypes.default.bool,
    className: _propTypes.default.string,
    // Dynamic props-type checks based on value of `isNewVersion`
    // eslint-disable-next-line consistent-return
    defaultValue: function defaultValue(props, propName) {
      var value = props[propName];
      var type = (0, _typeof2.default)(value);
      var hasValue = value !== undefined && value !== null;

      if (hasValue && !props.isNewVersion && type !== 'object') {
        /* istanbul ignore next */
        return new Error( // eslint-disable-next-line max-len
        "Failed prop type: Invalid prop `defaultValue` of type `".concat(type, "` supplied to `Dropdown`, expected `object`."));
      }

      if (hasValue && props.isNewVersion && type !== 'string') {
        /* istanbul ignore next */
        return new Error( // eslint-disable-next-line max-len
        "Failed prop type: Invalid prop `defaultValue` of type `".concat(type, "` supplied to `Dropdown`, expected `string`."));
      }
    },
    width: _propTypes.default.string,
    viewport: _propTypes.default.oneOf(Object.values(_constant2.DEVICE_TYPE)),
    iconColor: _propTypes.default.string,
    locale: _propTypes.default.shape(locale),
    isFocused: _propTypes.default.bool,
    recentSearchIcon: _propTypes.default.string,
    supportOneCharacterSearch: _propTypes.default.bool,
    mWidth: _propTypes.default.string,
    isNewVersion: _propTypes.default.bool,
    hideMobileIcon: _propTypes.default.bool,
    validateStatus: (0, _propTypes.oneOf)([_constant3.VALIDATE_STATUS_SUCCESS, _constant3.VALIDATE_STATUS_ERROR]),
    validateMessage: _propTypes.default.string,
    onClickCallback: _propTypes.default.func,
    customDisplayValue: _propTypes.default.string,
    customDisplayField: _propTypes.default.string,
    withBoxShadow: _propTypes.default.bool,
    showIconBackground: _propTypes.default.bool,
    isShowCancel: _propTypes.default.bool,
    onClear: _propTypes.default.func,
    autoSelectOneResult: _propTypes.default.bool,
    showOptionsfromTop: _propTypes.default.bool,
    hideLabelWhenFocus: _propTypes.default.bool,
    cancelIconColor: _propTypes.default.string,
    backgroundColorItems: _propTypes.default.string,
    noneHighLightInput: _propTypes.default.bool,
    notHighLight: _propTypes.default.bool,
    showSearchFor: _propTypes.default.bool,
    hideRecentLabel: _propTypes.default.bool,
    height: _propTypes.default.string,
    allowPlaceholderColorMobile: _propTypes.default.bool,
    hotelIcon: _propTypes.default.string,
    isDropdown: _propTypes.default.bool,
    isCountryCode: _propTypes.default.bool,
    isPlacePickerDropdown: _propTypes.default.bool,
    holidayDropdown: _propTypes.default.bool,
    fireGtm: _propTypes.default.func,
    isHotelSearchWidget: _propTypes.default.bool,
    isForListingPage: _propTypes.default.bool,
    highlightText: _propTypes.default.bool,
    cityLevelGrouping: _propTypes.default.bool,
    enableOnChangeOnceEmpty: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    width: '100%',
    accessible: true,
    isFocused: false,
    supportOneCharacterSearch: false,
    onChange: function onChange() {},
    onSelect: function onSelect() {},
    onBlur: function onBlur() {},
    onFocus: function onFocus() {},
    isNewVersion: false,
    hideMobileIcon: false,
    locale: _constant3.LOCALE,
    withBoxShadow: true,
    showIconBackground: false,
    isShowCancel: false,
    onClear: function onClear() {},
    autoSelectOneResult: false,
    showOptionsfromTop: false,
    hideLabelWhenFocus: false,
    noneHighLightInput: false,
    notHighLight: false,
    showSearchFor: false,
    hideRecentLabel: false,
    height: '',
    allowPlaceholderColorMobile: false,
    isDropdown: false,
    isCountryCode: false,
    isPlacePickerDropdown: false,
    holidayDropdown: false,
    isHotelSearchWidget: false,
    isForListingPage: false,
    highlightText: false,
    enableOnChangeOnceEmpty: false
  }
};
exports.default = _default;